/*!
    * @product/scmp-sdk 1.3.0
    * built by undefined
  */
function n(){if(!(typeof window>"u"))return window}export{n as a};
//# sourceMappingURL=chunk-WYLRUSW7.js.map
